/**
 * This module defines the specification for properties that
 * ParticipatoryProjects are expected or permitted to have.
 */
import { getPropertiesMap } from "./commonProperties";
export const tabGroups = [{
        group: "projectGeneral",
        title: "General",
        description: "General settings that govern functionality.",
        canonicalOrder: null,
    }, {
        group: "projectSchedule",
        title: "Schedule",
        description: "Settings that govern project schedule.",
        canonicalOrder: null,
    }, /*{
        group: "projectCard",
        title: "Card",
        description: "Settings that govern project's public display card.",
        canonicalOrder: null,
    }*/
];
/**
 * The list of properties expected for a ParticipatoryProject.
 */
export const ParticipatoryProjectPropertiesList = [
    {
        "key": "questionnaireId",
        "type": "resourceId",
        "isResourceId": "questionnaire",
        "inputType": "questionnaireId",
        "tabGroup": "projectGeneral",
        "default": null,
        "title": "Project Questionnaire",
        "description": "The questionnaire for this project",
    },
    {
        "key": "primaryCategories",
        "type": "list.string",
        "inputType": "textItemMany",
        "tabGroup": "projectGeneral",
        "default": null,
        "title": "Thematic categories",
        "description": "A list of themes which can be used to categorize ideas and proposals in this project.",
    },
    {
        "key": "secondaryCategories",
        "type": "list.string",
        "inputType": "textItemMany",
        "tabGroup": "projectGeneral",
        "default": null,
        "title": "Location categories",
        "description": "A list of geographic locations which can be used to categorize ideas and proposals in this project.",
    },
    {
        "key": "availableLanguages",
        "type": "list.string",
        "tabGroup": "projectGeneral",
        "inputType": "languageOptionMany",
        "default": [],
        "title": "Available languages",
        "description": "The list of languages for which this project has translations available.",
        "multilingual": false,
    },
    // {
    //     "key": "contactEmailAddress",
    //     "type": "string",
    //     "inputType": "text",
    //     "tabGroup": "projectCard",
    //     "default": null,
    //     "title": "Contact email address",
    //     "description": "Email address for participants to contact the people managing the project.",
    //     "multilingual": true,
    //     "hiddenFromInterface": true,
    // },
    // {
    //     "key": "contactPhoneNumber",
    //     "type": "string",
    //     "inputType": "text",
    //     "tabGroup": "projectCard",
    //     "default": null,
    //     "title": "Contact telephone number",
    //     "description": "Telephone number for participants to contact the people managing the project.",
    //     "multilingual": true,
    //     "hiddenFromInterface": true,
    // },
    // {
    //     "key": "contactAddress",
    //     "type": "string",
    //     "inputType": "text",
    //     "tabGroup": "projectCard",
    //     "default": null,
    //     "title": "Contact mailing address",
    //     "description": "Physical mailing address for participants to contact the people managing the project.",
    //     "multilingual": true,
    //     "hiddenFromInterface": true,
    // },
    // {
    //     "key": "title",
    //     "type": "string",
    //     "inputType": "text",
    //     "tabGroup": "projectCard",
    //     "default": null,
    //     "title": "Project title",
    //     "description": "The public project title.",
    //     "multilingual": true,
    // },
    // {
    //     "key": "description",
    //     "type": "string",
    //     "inputType": "textarea",
    //     "tabGroup": "projectCard",
    //     "default": null,
    //     "title": "Project description",
    //     "description": "A short public description.",
    //     "multilingual": true,
    // },
];
/**
 * The properties expected for a ParticipatoryProject, mapped by key.
 */
export const ParticipatoryProjectPropertiesMap = getPropertiesMap(ParticipatoryProjectPropertiesList);
//# sourceMappingURL=participatoryProject.js.map